const softHyphenate = (text) => (text.split("").join("\u{00AD}"));

export default softHyphenate;
